export default {
  props: {
    pagePopUpConfig: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  }
};